import {ModuleConfiguration} from "../router/model/UserPermission";
import {AddressModuleName, NgMessagesModule} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const AddressModuleConfiguration = new ModuleConfiguration(
    AddressModuleName,
    [AngularJsMaterialModuleName, NgMessagesModule]
);
